




































































































































































































































import ModalOptions from '@/shared/modal/modal-options.entity';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VMoney } from 'v-money';
import moment from 'moment';
import RequestExpirationContract from '@/domain/contract/entity/request-expiration-contract.entity';
import Justify from '@/domain/justify/domain/justify.entity';
import JustifyService from '@/domain/justify/service/justify.service';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import AddButton from '@/shared/buttons/add-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import FilterUtils from '@/shared/utils/filters';
import ReasonsCancellationService from '@/domain/justify/service/reasons-cancellation.service';

@Component({
  components: {
    ModalComponent,
    LabelSlot,
    VbTooltipSlot,
    AddButton,
    MainButton,
  },
  directives: {
    money: VMoney,
  },
})
export default class RequestCancelContract extends Vue {
  @Prop({
    type: Boolean,
  }) showModal!: boolean;

  @Prop({
    required: true,
  }) businessUnitId!: string;

  @Prop({
    required: true,
  }) loadingOk: boolean = false;

  @Prop({
    required: true,
    default: false,
  }) isContractGroup!: boolean;

  @Prop({
    type: RequestExpirationContract,
  }) cancelContractRequest!: RequestExpirationContract;

  @Prop() isAdministratorOrSupervisor!: boolean;

  rules: Rules = new Rules();

  valid: boolean = false;

  fineRequiredError: boolean = false;

  ref: any = this.$refs;

  justifications: Justify[] = [];

  loadingJustifications: boolean = false;

  maxDateSolicitation: string = moment().format('YYYY-MM-DD');

  minDateSolicitation: string = moment().format('YYYY-MM-DD');

  justificationIdsBlockedDateCustom: string[] = [
    '83476cba-1fc6-4393-b6b0-ae9b9a0cdb13', // Inadimplência de Pagamento
    '9081254e-fbc8-4765-aeb7-8e6ac9748025', // Inadimplência por falta de contato
  ];

  inputCobrarMulta: boolean = false;

  inputIsentarMulta: boolean = false;

  inputVigenciaContratual: boolean = false;

  exemptFineValue: number = 0;

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: 'R$ ',
    masked: false,
    max: 9999.99,
    min: 0.01,
  };

  reasonsCancellationList: Object[] = [];

  showAllowReasonsCancellation: boolean = false;

  billLastInvoiceRules = [
    (v: boolean | null) => v === true || v === false || 'Campo obrigatório',
  ];

  get reasonsCancellationDisabled(): boolean {
    return this.cancelContractRequest.justification == null
      || this.cancelContractRequest.justification === undefined
      || this.reasonsCancellationList.length === 0;
  }

  get reasonsCancellationRequiredRules() {
    const isRequired = !!this.cancelContractRequest.justification
      && this.reasonsCancellationList.length > 0
      && this.showAllowReasonsCancellation;
    return isRequired ? this.rules.empty : [];
  }

  loadedAllowReasonsCancellation() {
    ReasonsCancellationService.getBusinessUnitAllowReasonsCancellation(this.businessUnitId)
      .then((response: boolean) => this.showAllowReasonsCancellation = response)
      .catch(() => this.showAllowReasonsCancellation = false);
  }

  @Watch('cancelContractRequest.justification')
  loadReasonsCancellationList() {
    this.cancelContractRequest.reasonsCancellation = '';
    if (this.cancelContractRequest.justification === undefined
      || this.cancelContractRequest.justification == null
    ) {
      this.reasonsCancellationList = [];
      return;
    }
    ReasonsCancellationService.getByJustificationId(
      this.businessUnitId,
      this.cancelContractRequest.justification,
    )
      .then((response) => {
        const filteredResponse = response.map((item) => {
          const reason = {
            id: item.id,
            name: item.name,
          }
          return reason;
        });
        this.reasonsCancellationList = filteredResponse;
      })
      .catch((err: any) => {
        this.reasonsCancellationList = [];
        VbSnackbarService.handleHttpError(err)
      });
  }

  @Watch('inputCobrarMulta')
  onInputCobrarMultaChange(val: boolean) {
    if (val) {
      this.resetCobranca();
      this.inputIsentarMulta = !val;
      this.inputVigenciaContratual = !val;
      this.cancelContractRequest.exemptFineApprover = '';
      this.cancelContractRequest.exemptFine = false;
      this.cancelContractRequest.exemptFineForValue = val;
    }
  }

  resetCobranca() {
    this.cancelContractRequest.exemptFineApprover = '';
    this.cancelContractRequest.exemptFine = false;
    this.cancelContractRequest.exemptFineForValue = false;
    this.cancelContractRequest.exemptFineValue = 0;
    this.cancelContractRequest.exemptContractualTerm = false;
  }

  @Watch('inputIsentarMulta')
  onInputIsentarMultaChange(val: boolean) {
    if (val) {
      this.resetCobranca();
      this.inputCobrarMulta = !val;
      this.inputVigenciaContratual = !val;
      this.cancelContractRequest.exemptFine = val;
      this.cancelContractRequest.exemptFineValue = 0;
      this.cancelContractRequest.exemptFineForValue = false;
    }
  }

  @Watch('inputVigenciaContratual')
  onInputVigenciaContratualChange(val: boolean) {
    if (val) {
      this.resetCobranca();
      this.inputCobrarMulta = !val;
      this.inputIsentarMulta = !val;
      this.cancelContractRequest.exemptContractualTerm = val;
    }
  }

  setExemptFineValue(value: any) {
    const val = FilterUtils.formatValue(value);
    this.cancelContractRequest.exemptFineValue = val;
  }

  validateCheckboxAppover(): boolean {
    const contract = this.cancelContractRequest;
    if (contract.exemptFine === true && !contract.exemptFineApprover) {
      return false;
    }
    if (contract.exemptFineForValue === true && !contract.exemptFineValue) {
      return false;
    }
    if (this.inputCobrarMulta === false
      && this.inputIsentarMulta === false
      && this.inputVigenciaContratual === false
    ) {
      return false;
    }
    return true;
  }

  save() {
    this.fineRequiredError = false;
    if (!this.validateCheckboxAppover()) {
      this.fineRequiredError = true;
      return;
    }
    if (this.ref.form.validate()) {
      this.$emit('send', this.cancelContractRequest);
    }
  }

  cancel() {
    this.$emit('cancel', false);
  }

  get options(): ModalOptions {
    return {
      title: 'Solicitação de Encerramento do Contrato',
      titleAlign: 'center',
      showClose: true,
      showOk: true,
      loadingOk: this.loadingOk,
      disabledOk: !this.valid,
      labelOk: 'Confirmar',
      okColor: 'bluePrimary',
      showCancel: !this.loadingOk,
      labelCancel: 'Cancelar',
      width: 1250,
      persistent: true,
    }
  }

  menuDataField: boolean = false;

  menuDataFieldPersonalized: boolean = false;

  disabledDate: boolean = false;

  disabledDatePersonalized: boolean = true;

  disabledJustification: boolean = true;

  hintCancelAllContractGroup: string =
    'Os dados informados nessa solicitação serão aplicadas a todos os contratos do grupo.';

  hintCustomExpiration: string =
    'Utiliza operação para expiração personalizada definida no sistema ERP.';

  hintFineContract: string = 'Informar o nome do responsável por isentar a multa.';

  hintFineValue: string = 'Informar o valor da multa.';

  clearRequestDate() {
    this.cancelContractRequest.requestDate = '';
  }

  clearRequestDatePersonalized() {
    this.cancelContractRequest.customDateExpiration = '';
  }

  disableMonths(val): boolean {
    return this.disabledBeforeMonths(val);
  }

  disabledBeforeMonths(val) {
    return val >= moment().subtract(3, 'months').format('YYYY-MM').substr(0, 10);
  }

  @Watch('showModal')
  getLists() {
    this.getJustifications();
    this.loadedAllowReasonsCancellation();
  }

  getJustifications() {
    if (this.showModal) {
      this.loadingJustifications = true;
      JustifyService.getJustificationsByBusinessUnitAndType(
        this.businessUnitId,
        JustifyType.CONTRACT_MARKED_EXPIRE,
      )
        .then((response: Justify[]) => this.justifications = response)
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => { this.loadingJustifications = false; });
    }
  }

  disabledDates() {
    if (this.isJustificationBlockedDatePersonalized()) {
      this.disabledDate = true;
      this.disabledDatePersonalized = true;

      const data = this.cancelContractRequest.requestDate;
      this.cancelContractRequest.customDateExpiration = data;
      return;
    }

    this.disabledDate = false;
    this.disabledDatePersonalized = this.cancelContractRequest.requestDate === '';
    this.disabledJustification = this.cancelContractRequest.requestDate === '';
  }

  isJustificationBlockedDatePersonalized(): boolean {
    return this.justificationIdsBlockedDateCustom
      .includes(this.cancelContractRequest.justification);
  }

  @Watch('cancelContractRequest.justification')
  disabledPersonalized(): boolean {
    this.disabledDates();
    return this.cancelContractRequest.requestDate === '';
  }

  @Watch('cancelContractRequest.requestDate')
  maxDateSolicitationPlus30() {
    this.disabledDates();
    const requestDate = this.cancelContractRequest.requestDate;
    const momentMaxDate30 = moment(requestDate).add(30, 'days');

    this.minDateSolicitation = requestDate;
    this.maxDateSolicitation = momentMaxDate30.format('YYYY-MM-DD');

    this.cancelContractRequest.customExpiration = true;
    this.cancelContractRequest.customDateExpiration = '';
  }
}
